import posthog from "posthog-js";

const initPostHog = () => {
  // Check if domain is local or not to avoid tracking in development
  if (typeof window === "undefined") return;
  const host = window.location.hostname || "";
  const isLocalDomain =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "::1" ||
    host === "0.0.0.0" ||
    host.startsWith("192.") ||
    host.endsWith(".local");

  if (isLocalDomain) {
    console.log("PostHog tracking is disabled on local domains.");
    return;
  }

  posthog.init("phc_zC6MGUo8RZUSl8dQtvgurads8vccdb45sXLBwMw6MAv", {
    api_host: "https://eu.i.posthog.com",
    defaults: "2025-05-24",
    person_profiles: "identified_only",
    autocapture: true,
    capture_exceptions: true,
  });
};

export default initPostHog;
